import { useEffect, useState } from "react";
import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

const useSignalR = ( url: string, fileId?: string ) => {
	
	const [ connection, setConnection ] = useState<HubConnection|undefined>(undefined);

  	useEffect(() => {
		let canceled = false;
		const connection = new HubConnectionBuilder()
			.withUrl(url)
			.withAutomaticReconnect([0, 2000, 10000, 20000])
			.configureLogging(LogLevel.Information)
			.build();

		connection
			.start()
			.then(() => {
				if (!canceled) {
					setConnection(connection);
					connection.invoke("selectFile", { fileId } );
				}
			})
			.catch((error) => {
				console.log("signal error", error);
			});

		connection.onclose((error) => {
			if (canceled) {
				return;
			}
			console.log("signal closed");
			setConnection(undefined);
		});

		connection.onreconnecting((error) => {
			if (canceled) {
				return;
			}
			console.log("signal reconnecting");
			setConnection(undefined);
		});

		connection.onreconnected((error) => {
			console.info("Хаб переподключился, посылаем сигнал серверу");
			connection.invoke("selectFile",  { fileId } );
		});

		// Clean up the connection when the component unmounts
		return () => {
			canceled = true;
			connection.stop();
		};
	// eslint-disable-next-line
  	}, [] );

	return { connection };
};

export default useSignalR;
